module.exports = __webpack_public_path__ + "img/icone_studio_medical.61635c1f.png";